import React, { useCallback, useMemo } from 'react';
import { FlowContextWrapper } from '@getvim/flow-context-provider';
import { Loader } from '@getvim/atomic-ui';
import { useVimAuth } from '@getvim/internal-vim-os-sdk/react';
import { eligibilityLogger } from '../utils/logger';
import { GraphqlClient } from '../api/graphqlClient';

export const RequiredStateWrapper: React.FC = ({ children }) => {
  const { accessToken } = useVimAuth();
  const mandatoryState = useMemo(() => {
    if (accessToken) {
      GraphqlClient.setAccessToken(accessToken);
    }

    return {
      accessToken: Promise.resolve(accessToken),
    };
  }, [accessToken]);

  const onError = useCallback(() => {
    eligibilityLogger.error('Failed to fetch state in App RequiredStateWrapper', {
      mandatoryState,
    });
  }, [mandatoryState]);

  return (
    <FlowContextWrapper loader={<Loader type="dots" />} state={mandatoryState} onError={onError}>
      {children}
    </FlowContextWrapper>
  );
};
